import { render, staticRenderFns } from "./wage-list.vue?vue&type=template&id=540a8522&scoped=true"
import script from "./wage-list.vue?vue&type=script&lang=js"
export * from "./wage-list.vue?vue&type=script&lang=js"
import style0 from "./wage-list.vue?vue&type=style&index=0&id=540a8522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a8522",
  null
  
)

export default component.exports